import { DatePickerChangeEvent, DatePicker } from "@progress/kendo-react-dateinputs"
import { FieldRenderProps } from "@progress/kendo-react-form"
import React from "react"

const StartDateComponent = (fieldRenderProps: FieldRenderProps) => {
    const {disabled, value, onChange, updateDate} = fieldRenderProps

    const updateStartDate = (event: DatePickerChangeEvent) => {
        onChange(event)
    }

    const onBlurDate = (event: any) => {
        if (event.target.tagName === "INPUT") {
            updateDate(event.target)
        }
    }

    return (
        <DatePicker
            disabled={disabled}
            value={value}
            onChange={updateStartDate}
            onBlur={onBlurDate}
            label="Date"
            min={new Date()}
            required
        />
    )
}

export default React.memo(StartDateComponent, (prevState, newState) => {
    return prevState.value === newState.value
})
